import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Skeleton } from 'antd';
import { Evaluations } from './Tables';

const Evaluation = () => {
  const { id, formID } = useParams();
  const { state } = useLocation();
  const apaData = useSelector((store) => store.apa.apaData);
  const form = apaData?.find((item) => item.form_no === formID);
  if (!form) return <Skeleton active />;
  // Navigation state is optional; identity and section always come from the URL.
  const year = state?.rowUser === id ? Number(state.year) : NaN;
  const menu = {
    ...form,
    rowUser: id,
    currentApaId: form.id,
    currentMenuId: formID,
    year: year || new Date().getFullYear() - 1,
  };
  return <Evaluations key={`${id}/${formID}/${menu.year}`} menu={menu} />;
};

export default Evaluation;
